import { Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { navigate } from 'gatsby';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import ContentLoader from '@components/ContentLoader';
import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import { ProcessStepper } from '@components/ProcessStepper/index';
import RecordCard from '@components/RecordCard';

import * as ROUTES from '@constants/routes';

import { useGetAllergies } from '@hooks/api/allergy';

import { NoRecordsWrapper } from '@layouts/Layouts/BigTitleLayout';

import { sortAllergies } from '@utils/sort/records';

const messages = defineMessages({
  title: {
    id: 'allergiesMain.allergies',
    defaultMessage: 'Allergies',
  },
  noRecordsFound: {
    id: 'allergiesMain.noRecordsFound',
    defaultMessage: 'No Known Allergy Records',
  },
});

const Allergies: React.FC = () => {
  const { data, loading } = useGetAllergies();

  const { formatMessage } = useIntl();
  const { palette } = useTheme();

  return (
    <ContentLoader loading={loading}>
      <Container maxWidth="sm">
        <ProcessStepper
          allBlack
          stepNames={data.sort(sortAllergies).map((a) => (
            <RecordCard
              color={a.isSevere ? palette.secondary.main : undefined}
              coloredSubtext={a.isSevere}
              key={a.id}
              noteDisplay={Boolean(a.recordNotes.length)}
              onClick={() => {
                navigate(`${ROUTES.ALLERGIES}${a.id}`);
              }}
              recordSource={a.recordSource}
              status={a.curationStatus}
              text={a.substance}
              topText={a.reactionGrade === 'Unknown' ? '' : a.reactionGrade}
              viewed={a.viewedStatus}
            />
          ))}
        />

        {data.length === 0 && (
          <NoRecordsWrapper>
            {formatMessage(messages.noRecordsFound)}
          </NoRecordsWrapper>
        )}
      </Container>
    </ContentLoader>
  );
};

export default withErrorBoundary(Allergies, {
  FallbackComponent: ErrorBoundaryFallback,
});
